import { useQueryClient } from "@tanstack/react-query";
import { Button } from "antd";
import { t } from "i18next";

import FilterableTableLayout from "../../../../components/FilterableTableLayout/FilterableTableLayout";
import { PersistedFilterKeys } from "../../../../modules/filters/filters.types";
import {
  getMfListaObjekataPsExcelColumns,
  getMfListaObjekataPsFilterItems,
  getMfListaObjekataPsTableColumns,
  MF_OBJEKTI_PRIVREDNIH_SUBJEKATA_INITIAL_FILTERS,
} from "../../../../modules/ministry/centralRegistry/centralRegistry.constants";
import { centralRegistryKeys } from "../../../../modules/ministry/centralRegistry/centralRegistry.keys";
import {
  useMfListaObjekataPsList,
  useMfTipoviObjekata,
} from "../../../../modules/ministry/centralRegistry/centralRegistry.queries";
import {
  MfListaObjekataPsPayload,
  MfListaObjekataPsProps,
} from "../../../../modules/ministry/centralRegistry/centralRegistry.types";
import { ApiResponseObject } from "../../../../types";
import { writeExcel } from "../../../../utils/writeExcel";
import style from "./ObjektiPrivrednihSubjekata.module.scss";

const ObjektiPrivrednihSubjekataExportButton = () => {
  const queryClient = useQueryClient();

  const handleExportExcel = () => {
    const cachedQueries = queryClient.getQueriesData<
      ApiResponseObject<MfListaObjekataPsProps[]>
    >({
      queryKey: centralRegistryKeys.mfListaObjekataPs._def,
    });
    const latestData = cachedQueries.at(-1)?.[1];

    writeExcel(
      latestData?.data ?? [],
      getMfListaObjekataPsExcelColumns(),
      "objekti_privrednih_subjekata"
    );
  };

  return (
    <Button onClick={handleExportExcel}>{`${t("COMMON.IZVEZI_U")} Excel`}</Button>
  );
};

export const ObjektiPrivrednihSubjekata = () => {
  const { data: tipObjektaOptions, isLoading: isLoadingTipoviObjekata } =
    useMfTipoviObjekata();

  return (
    <FilterableTableLayout<
      MfListaObjekataPsProps,
      ApiResponseObject<MfListaObjekataPsProps[]>,
      MfListaObjekataPsPayload
    >
      tableRowKey="idObjekta"
      dataListKey="data"
      getTableColumns={getMfListaObjekataPsTableColumns}
      queryHook={useMfListaObjekataPsList}
      tableName="objekti-privrednih-subjekata-table"
      title={t("NAVIGATION.OBJEKTI_PRIVREDNIH_SUBJEKATA")}
      toolbarId="mfin_objekti_privrednih_subjekata_list"
      filterProps={{
        getFilterItems: () =>
          getMfListaObjekataPsFilterItems({
            tipObjektaOptions,
            isLoading: isLoadingTipoviObjekata,
          }),
        initialFilters: MF_OBJEKTI_PRIVREDNIH_SUBJEKATA_INITIAL_FILTERS,
        persistedFilterKey:
          PersistedFilterKeys.MFIN_OBJEKTI_PRIVREDNIH_SUBJEKATA_LIST,
        filterToolbarClassName: style.filterToolbar,
      }}
      toolbarActions={<ObjektiPrivrednihSubjekataExportButton />}
    />
  );
};
